import { render, staticRenderFns } from "./OnboardingCertifiedSeal.vue?vue&type=template&id=7b6cf51c"
import script from "./OnboardingCertifiedSeal.vue?vue&type=script&lang=js"
export * from "./OnboardingCertifiedSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports